import { userRouter } from '../../route'
import { RouteComponetParam } from '../../tools/public'
import { AnyAction } from 'redux'
// action 类型定义
const ACTION_TYPE = {
  ADD_DATA: 'router/ADD_DATA', // 设置 路由页面 组件
  DEL_DATA: 'router/DEL_DATA', // 删除 路由页面 组件
  RESET_DATA: 'router/RESET_DATA', // 重置 路由页面 组件
}
const RouteList = userRouter[1].router || []
interface State {
  routerList: RouteComponetParam[]
}
// 默认数据
const defaultState: State = {
  routerList: RouteList,
}

// 默认 Reducer
export default function reducer(state = defaultState, action: AnyAction) {
  const arr = { ...state }
  switch (action.type) {
    case ACTION_TYPE.ADD_DATA:
      arr.routerList = [...arr.routerList, ...[action.value]]
      return arr
    case ACTION_TYPE.DEL_DATA:
      // 过滤 不可删除的路由数据
      const orglist = arr.routerList.filter((i) => i.keyName === i.key)
      // 过滤 可删除的路由数据
      const list = arr.routerList.filter((i) => i.keyName !== i.key)
      const newlist = list.filter((item) => item.key !== action.value)
      arr.routerList = [...orglist, ...newlist]
      return arr
    case ACTION_TYPE.RESET_DATA:
      arr.routerList = RouteList
      return arr
    default:
      return state
  }
}
// 新增路由组件 注意key不能相同
export const addRouterAction = (param: RouteComponetParam) => ({
  type: ACTION_TYPE.ADD_DATA,
  value: param,
})

// 删除路由组件
export const delRouterAction = (param: string) => ({
  type: ACTION_TYPE.DEL_DATA,
  value: param,
})
// 重置路由组件
export const resetRouterAction = () => ({
  type: ACTION_TYPE.RESET_DATA,
})
import { userRouter } from '../../route'
import { RouteComponetParam } from '../../tools/public'
import { AnyAction } from 'redux'
// action 类型定义
const ACTION_TYPE = {
  ADD_DATA: 'router/ADD_DATA', // 设置 路由页面 组件
  DEL_DATA: 'router/DEL_DATA', // 删除 路由页面 组件
  RESET_DATA: 'router/RESET_DATA', // 重置 路由页面 组件
}
const RouteList = userRouter[1].router || []
interface State {
  routerList: RouteComponetParam[]
}
// 默认数据
const defaultState: State = {
  routerList: RouteList,
}

// 默认 Reducer
export default function reducer(state = defaultState, action: AnyAction) {
  const arr = { ...state }
  switch (action.type) {
    case ACTION_TYPE.ADD_DATA:
      arr.routerList = [...arr.routerList, ...[action.value]]
      return arr
    case ACTION_TYPE.DEL_DATA:
      // 过滤 不可删除的路由数据
      const orglist = arr.routerList.filter((i) => i.keyName === i.key)
      // 过滤 可删除的路由数据
      const list = arr.routerList.filter((i) => i.keyName !== i.key)
      const newlist = list.filter((item) => item.key !== action.value)
      arr.routerList = [...orglist, ...newlist]
      return arr
    case ACTION_TYPE.RESET_DATA:
      arr.routerList = RouteList
      return arr
    default:
      return state
  }
}
// 新增路由组件 注意key不能相同
export const addRouterAction = (param: RouteComponetParam) => ({
  type: ACTION_TYPE.ADD_DATA,
  value: param,
})

// 删除路由组件
export const delRouterAction = (param: string) => ({
  type: ACTION_TYPE.DEL_DATA,
  value: param,
})
// 重置路由组件
export const resetRouterAction = () => ({
  type: ACTION_TYPE.RESET_DATA,
})
